import React, { useMemo } from 'react'
import VerticalSidebar from '../Components/Molecules/VerticalSidebar'
import TopMenu from '../Menu/TopMenu'
import useStore, { getState } from '../../../store'
import { Card } from '@material-ui/core'
import { Redirect } from 'react-router-dom'
import { Lang } from '../../../Utils'
import MiddleMenu from '../Menu/MiddleMenu'
import { START_STEP } from '../../../config'
import SelectDTDSimple from '../Menu/SelectDTDSimple'

/**
 * @returns {*}
 * @constructor
 */
const SelectDTDIn = ({ fullScreenHandle, onClickSteps }) => {
  const objType = getState().objType
  const mainSize = getState().mainSize
  const selectedDTDType = useStore((state) => state.selectedDTDType)
  const mainDTDId = useStore((state) => state.mainDTDId)

  const isTypeNotSelected = useMemo(() => {
    return objType === ''
  }, [objType])

  if (isTypeNotSelected) {
    return <Redirect to={'/' + Lang(START_STEP, 'navigation')} />
  }

  return (
    <>
      <TopMenu />
      <MiddleMenu fullScreenHandle={fullScreenHandle} onClickSteps={onClickSteps} />
      <Card>
        <SelectDTDSimple
          mainSize={mainSize}
          objType={objType}
          selectedDTDType={selectedDTDType}
          onClickSteps={onClickSteps}
          dtdId={mainDTDId}
        />
      </Card>
      <VerticalSidebar onClickSteps={onClickSteps} />
    </>
  )
}

export default SelectDTDIn
